import { render, staticRenderFns } from "./EditDividendHistoryTitle.vue?vue&type=template&id=72afc560&"
import script from "./EditDividendHistoryTitle.vue?vue&type=script&lang=js&"
export * from "./EditDividendHistoryTitle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VSpacer})
